<template>
  <div>
    <div class="fixed-top">
      <div class="container-fluid bg-third shadow-sm text-nowrap" style="height: 39px; padding-top: 7px; padding-bottom: 7px">
        <router-link to="/pdv" class="text-white text-decoration-none">
          <i class="fa fa-chevron-left mr-2"/><span class="small font-weight-bold"> Voltar</span>
        </router-link>
      </div>
    </div>
    <div style="margin-top: 62px">
      <loading v-if="load"/>
      <div class="container-fluid" v-show="!load">
        <div class="card shadow-sm mb-4">
          <div class="card-body text-center text-md-left">
            <div class="row align-items-end">
              <div class="col-md-6 col-lg-4 col-xl-3 mb-1">
                <label class="small font-weight-bold mb-0">Data Início</label>
                <input type="date" id="data" class="form-control" v-model="pesquisa.dt_inicio">
              </div>
              <div class="col-md-6 col-lg-4 col-xl-3 mb-1">
                <label class="small font-weight-bold mb-0">Data Final</label>
                <input type="date" id="dataAte" class="form-control" v-model="pesquisa.dt_fim">
              </div>
              <div class="col-lg-2 mt-2 mt-lg-0 mb-1 ml-auto">
                <button class="btn btn-warning btn-block" @click="buscarProdutos()">Pesquisar</button>
              </div>
            </div>
          </div>
        </div>

        <div class="card shadow-sm mb-4">
          <div class="card-body">
            <div class="table-responsive" style="min-height: 100px">
              <table class="table mb-0">
                <tr>
                  <th>Produto</th>
                  <th class="text-center">Qtd</th>
                  <th class="text-center">Comissão</th>
                  <th class="text-center">Vendas</th>
                </tr>
                <tr v-for="(p, index) in produtos" :key="index">
                  <td>
                    {{p.nome_produto}}
                    <div class="small">{{p.nome_categoria}}</div>
                  </td>
                  <td class="text-center align-middle">{{p.qtd | qtd}}</td>
                  <td class="text-center align-middle">{{p.comissao | valor}}</td>
                  <td class="text-center align-middle">{{p.valor | valor}}</td>
                </tr>
                <tr v-if="produtos.length">
                  <td><b>Total</b></td>
                  <td class="text-center"><b>{{quantidade | qtd }}</b></td>
                  <td class="text-center"><b>{{comissao | valor}}</b></td>
                  <td class="text-center"><b>{{total | valor}}</b></td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopBar from "@/components/commons/TopBar";
import Relatorios from "@/views/comanda/Relatorios";
import BarComanda from "@/components/pdv/BarComanda";
import Loading from "@/components/commons/Loading";

export default {
  name: 'Comissoes',
  components: {Loading, BarComanda, Relatorios, TopBar},
  data() {
    return {
      token: localStorage.getItem('key'),
      load: false,
      produtos: [],

      total: 0,
      quantidade: 0,
      comissao: 0,

      pesquisa: {
        dt_inicio: new Date().toDateInputValue(),
        dt_fim: new Date().toDateInputValue(),
        hr_inicio: '00:00',
        hr_fim: '23:59',
        json: 'true'
      }
    }
  },

  methods: {
    buscarProdutos() {
      this.total = 0;
      this.quantidade = 0;
      this.comissao = 0;
      this.load = true;

      this.$http.get('comandas/comissao/' + this.token, { params: this.pesquisa })
        .then(response => {
          this.load = false;

          if (!response.data || response.data.msg) {
            this.$swal(response.data && response.data.msg ? response.data.msg : 'Erro temporário');

          } else {
            this.produtos = (response.data || []).map(p => {
              return { ...p,
                valor_custo: parseFloat(p.valor_custo || '0') * parseFloat(p.qtd || '0'),
                comissao: (parseInt(p.comissao || '0') / 100) * parseFloat(p.valor)
              }
            });

            if (this.produtos.length) {
              this.total = this.produtos.map(p => parseFloat(p.valor || '0')).reduce((a, b) => a + b, 0);
              this.quantidade = this.produtos.map(p => parseFloat(p.qtd || '0')).reduce((a, b) => a + b, 0);
              this.comissao = this.produtos.map(p => p.comissao).reduce((a, b) => a + b, 0);
            }
          }

        }, res => {
          this.load = false;
          this.$swal(res.data && res.data.msg ? res.data.msg : "Erro Temporário");
        });
    },
  },

  mounted() {
    this.buscarProdutos();
  },

  filters: {
    qtd(value) {
      if (value && !isNaN(value)) {
        return parseFloat(value).toFixed();
      }
    }
  }
}
</script>
